export default {
  errorBrand: null,
  errorName: null,
  errorSendTime: null,
  errorCustomerDataType: null,
  errorFileKey: null,
  errorType: null,
  errorMessageTemplate: null,
  errorMessageTemplateSms: null,
  errorMessageTemplateLine: null,
  errorImageRelativePath: null,
  errorTargetUrl: null,
  errorPreviewImageRelativePath: null,
  errorVideoRelativePath: null,
  errorMessageTemplatePushNoti: null,
  errorPushNotiTargetUrl: null,
  errorShowInInbox: null,
  errorShowUntil: null,
  errorMessageTitle: null,
};
